import { ResponsiveContainer } from "recharts";
import styled from "styled-components";

export const PurchaseSaleWrapper = styled.div`
  width: 60%;
  background-color: white;
  border-radius: 10px;
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const PurchaseHeader = styled.div`
  width: 100%;
  padding: 10px;
  background-color: #f1f1f1;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  color: #000;
  border-bottom: 1px solid grey;
`;

export const BarChatWrapper = styled.div`
  width: 100%;
  height: 200px;
  padding: 20px;
  margin-right: 20px;
`;

export const ResponsiveContainerStyled = styled(ResponsiveContainer)`
  width: 100%;
  height: 130% !important;

  @media (max-width: 768px) {
    width: 100%;
    height: 100% !important;
  }
`;
